<template>
  <div class="card detail-card">
    <div class="card-body">
      <!-- Shop Image -->
      <div v-if="data.shop_image" class="shop-image-section">
        <img :src="data.shop_image" alt="店舗画像" class="shop-image-preview">
      </div>

      <div class="detail-grid">
        <!-- Shop Info -->
        <div class="detail-section">
          <h6 class="section-title"><i class="fas fa-store mr-2"></i>店舗情報</h6>
          <table class="table table-borderless detail-table">
            <tbody>
              <tr><th>店舗名</th><td>{{ data.shop_name }}</td></tr>
              <tr>
                <th>管理者</th>
                <td>
                  <span v-for="(staff, i) in filteredStaff" :key="staff.id">
                    {{ staff.name }}<span v-if="i < filteredStaff.length - 1">、</span>
                  </span>
                  <span v-if="filteredStaff.length === 0" class="text-muted">未設定</span>
                </td>
              </tr>
              <tr><th>スタッフ数</th><td>{{ data.number_of_staff }}名</td></tr>
              <tr><th>郵便番号</th><td>{{ data.postal_code }}</td></tr>
              <tr><th>住所</th><td>{{ data.address }}</td></tr>
              <tr><th>電話番号</th><td>{{ data.tel_number }}</td></tr>
              <tr><th>URL</th><td>{{ data.url }}</td></tr>
              <tr>
                <th>営業時間</th>
                <td>
                  <span v-if="data.opening_time && data.closing_time">
                    {{ formatTime(data.opening_time) }} 〜 {{ formatTime(data.closing_time) }}
                  </span>
                  <span v-else class="text-muted">未設定</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Settings -->
        <div class="detail-section">
          <h6 class="section-title"><i class="fas fa-cog mr-2"></i>設定</h6>
          <table class="table table-borderless detail-table">
            <tbody>
              <tr>
                <th>タイムカード調整</th>
                <td>
                  <span v-if="data.time_adjustment" class="badge-on">{{ data.time_adjustment }}分</span>
                  <span v-else class="badge-off">行わない</span>
                </td>
              </tr>
              <tr>
                <th>シフトパターン</th>
                <td>
                  <span v-if="data.shift_pattern_type === 2" class="badge-on">シフトパターン</span>
                  <span v-else class="badge-off">企業パターン</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-footer detail-footer">
      <button class="btn btn-outline-secondary" @click="$router.push({name:'CompanyShopPage'})">
        <i class="fas fa-arrow-left mr-1"></i>一覧に戻る
      </button>
      <div class="detail-footer-right">
        <button class="btn btn-primary" @click="edit">
          <i class="fas fa-edit mr-1"></i>編集
        </button>
        <button class="btn btn-outline-danger" @click="showDeleteModal = true">
          <i class="fas fa-trash mr-1"></i>削除
        </button>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div v-if="showDeleteModal" class="modal-overlay" @click.self="showDeleteModal = false">
    <div class="modal-box">
      <div class="modal-body text-center py-4">
        <i class="fas fa-exclamation-triangle text-danger mb-3" style="font-size: 2rem;"></i>
        <p class="mb-1"><strong>{{ data.shop_name }}</strong>を削除します。</p>
        <p class="text-muted mb-0">この操作は取り消せません。</p>
      </div>
      <div class="modal-footer-centered">
        <button type="button" class="btn btn-outline-secondary" @click="showDeleteModal = false">キャンセル</button>
        <button type="button" class="btn btn-danger" @click="remove">削除する</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        staff: [],
      },
      showDeleteModal: false,
    }
  },
  computed: {
    filteredStaff() {
      return (this.data.staff || []).filter(staff => staff.pivot && staff.pivot.manager_flag);
    },
  },
  mounted() {
    this.getShopDetails();
  },
  methods: {
    formatTime(t) {
      return t ? t.slice(0, 5) : '';
    },
    getShopDetails () {
      this.$http.get(process.env.VUE_APP_API_PATH + '/company/shop/' + this.$route.params.shop_id)
      .then(response => {
        this.data = response.data.data;
        this.data.number_of_staff = (this.data.staff || []).length;
      })
      .catch(error => {
        console.log(error);
      });
    },
    edit () {
      this.$router.push({name:'CompanyShopEditPage', params: {shop_id: this.$route.params.shop_id}});
    },
    remove () {
      this.$http.delete(process.env.VUE_APP_API_PATH + '/company/shop/' + this.$route.params.shop_id)
      .then(response => {
        this.showDeleteModal = false;
        this.$toast.success(response.data.message);
        setTimeout(() => {
          this.$router.push({name:'CompanyShopPage'});
        }, 1000);
      })
      .catch(error => {
        console.log(error);
      });
    }
  },
};
</script>

<style scoped>
.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

@media (max-width: 768px) {
  .detail-grid {
    grid-template-columns: 1fr;
  }
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #049C4C;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding-bottom: 10px;
  margin-bottom: 0;
  border-bottom: 2px solid #e2e8f0;
}

.detail-table th {
  width: 35%;
  font-weight: 600;
  font-size: 13px;
  color: #718096;
  padding: 10px 8px;
  border: none;
  white-space: nowrap;
}

.detail-table td {
  font-size: 15px;
  color: #1a202c;
  font-weight: 500;
  padding: 10px 8px;
  border: none;
}

.badge-on {
  display: inline-block;
  background: #c6f6d5;
  color: #22543d;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 4px;
}

.badge-off {
  display: inline-block;
  background: #e2e8f0;
  color: #718096;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 4px;
}

.detail-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f7fafc;
  border-top: 1px solid #e2e8f0;
}

.detail-footer-right {
  display: flex;
  gap: 12px;
}

.shop-image-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 12px;
  background: #f7fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.shop-image-preview {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-box {
  background: #fff;
  border-radius: 12px;
  width: 360px;
  max-width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.modal-footer-centered {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 16px 24px;
  background: #f7fafc;
  border-top: 1px solid #e2e8f0;
}
</style>
